import { useState, type ReactElement } from 'react';
import { AgentBar, emptyAgentBarState, type AgentBarState } from '../components/dock/ComposerDock';

export function AgentBarDevView(): ReactElement {
  const [state, setState] = useState<AgentBarState>(() => ({
    ...emptyAgentBarState(),
    auraPanelOpen: true,
    messagePreviewIndex: 0,
  }));

  return (
    <main className="agent-bar-dev-page">
      <header className="agent-bar-dev-header">
        <div>
          <span>AgentBar</span>
          <h1>State lab</h1>
        </div>
        <p>Review real component states, test transitions, and capture fixes without changing proposal data.</p>
      </header>
      <section className="agent-bar-dev-stage" aria-label="AgentBar test stage">
        <div className="agent-bar-dev-grid" aria-hidden="true" />
        <AgentBar
          mode="proposal"
          onSend={() => undefined}
          onStop={() => undefined}
          onRemoveQueued={() => undefined}
          onDismiss={() => undefined}
          onUndo={() => undefined}
          state={state}
          onStateChange={setState}
        />
      </section>
    </main>
  );
}
